import { Container } from "react-bootstrap";
import { HeaderModel } from "../../core/models/HeaderModel";

interface HeaderProps {
    header: HeaderModel;
}


function Header(props:HeaderProps) {
    const header = props.header;
    return (
        <>
            <Container>
                {header !== undefined ? (
                    <center>
                        <div
                            style={{
                                width: "100%",
                            }}
                        >
                            <div>
                                <h1
                                    style={{
                                        margin: 0,
                                        textAlign: "center",
                                        color: props.header.textColor ?? "white",
                                        fontSize: 72,
                                    }}
                                >
                                    {header.title}
                                </h1>
                            </div>
                            <br />
                            <a
                                href={header.image}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    style={{
                                        width: "80%",
                                        borderRadius: 25,
                                        marginTop: 20,
                                        marginBottom: 20,
                                        boxShadow: "3px 3px 10px #1e1e1e",
                                    }}
                                    src={header.image}
                                    alt={header.description}
                                />
                            </a>
                            <br />
                            <p
                                style={{
                                    fontSize: 33,
                                    color: "white",
                                    textAlign: "center",
                                    paddingBottom: 40,
                                }}
                            >
                                {header.description}
                            </p>
                        </div>
                    </center>
                ) : null}
            </Container>
        </>
    );
}

export default Header;